<script setup lang="ts">
import { SlidersHorizontal } from "@lucide/vue";

import { useEditBuildingProjectWizard } from "@/features/BuildingProject";

import StepCard from "@/features/BuildingProject/components/WizardFlow/StepCard.vue";
import StepIntro from "@/features/BuildingProject/components/WizardFlow/StepIntro/StepIntro.vue";
import ParameterMapping from "@/features/BuildingProject/components/WizardFlow/ParameterMapping";

// Settings-only section (RTLCA-5724), so it lives with the settings page rather than under WizardFlow. Which
// parameter carries the classification code decides how every result is grouped, so it gets a section of its
// own rather than a card under Models or on the Speckle connection screen. The create wizard keeps the same
// card inside its connection step.
const editBuildingProjectWizard = useEditBuildingProjectWizard();
</script>

<template>
  <div class="flex w-full flex-col">
    <StepIntro
      class="mb-6"
      heading="How are the model's elements classified?"
      hint="The classification code on each element is what groups the results. Say which system the model follows and which parameter holds the code." />

    <StepCard
      :icon="SlidersHorizontal"
      heading="Parameter mapping"
      caption="Choose the parameter where your authoring tool stores the classification code. It is read every time a new version arrives through Speckle, and the code is what structures the results.">
      <ParameterMapping :project="editBuildingProjectWizard.getProjectWrapper().project" />
    </StepCard>
  </div>
</template>
